/**
 * 生成uuid
 */
export function getUUID () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}

/**
 * 清除登录信息
 */
export function clearLoginInfo () {
  localStorage.removeItem('info')
  localStorage.removeItem('token')
}

/**
 * 获取商品id
 */
export function getIdFromUrl (url) {
  let res = {}
  let idMatchRes = url.match(/(\?|&)id=\d+/)
  let matchRes
  if (idMatchRes) {
    matchRes = idMatchRes[0].match(/\d+/g)
  }
  if (matchRes) {
    res = matchRes[0]
  }
  return res
}



// WEBPACK FOOTER //
// ./src/utils/index.js